<template>
  <div class="q-pa-md q-gutter-sm">
    <div class="row justify-center items-center">
      <q-banner class="bg-primary text-white">
        {{ bankInfo }}
      </q-banner>
    </div>
    <div class="row justify-center items-center">
      <div class="col-md-2">
        <q-select dir="ltr" filled v-model="bankYear" :options="years" label="سال"/>
      </div>
    </div>
    <div class="row justify-center items-center">
      <q-input :dense="$q.screen.lt.md" dir="ltr" filled v-model="startDate" mask="date" :rules="['date']" label="تاریخ شروع" clearable>
        <template v-slot:append>
          <q-icon name="event" class="cursor-pointer">
            <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
              <q-date v-model="startDate" calendar="persian">
                <div class="row items-center justify-center">
                  <q-btn v-close-popup label="تایید" color="primary" flat/>
                  <q-btn v-close-popup @click="startDate = ToJalaliDate(new Date())" label="امروز" color="primary"
                         flat/>
                </div>
              </q-date>
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
    <div class="row no-padding justify-center items-center">
      <q-input :dense="$q.screen.lt.md" dir="ltr" filled v-model="endDate" mask="date" :rules="['date']" label="تاریخ پایان" clearable>
        <template v-slot:append>
          <q-icon name="event" class="cursor-pointer">
            <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
              <q-date v-model="endDate" calendar="persian">
                <div class="row items-center justify-center">
                  <q-btn v-close-popup label="تایید" color="primary" flat/>
                  <q-btn v-close-popup @click="endDate = ToJalaliDate(new Date())" label="امروز" color="primary"
                         flat/>
                </div>
              </q-date>
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
    <div class="row justify-center items-center">
      <q-uploader
          label="انتخاب فایل گردش حساب بانک"
          :factory="factoryFn"
          method="POST"
          style="max-width: 300px"
          ref="uploader"
          :multiple="false"
          @rejected="onRejectUpload"
          @uploaded="onUploaded"
          @finish="onUploadFinshed"
      />
    </div>
    <div class="row q-pa-md justify-center">
      <div class="col-md-8 col-sm-12">
        <q-expansion-item
            class="shadow-1 overflow-hidden q-ma-sm"
            icon="explorer"
            header-class="bg-primary text-white"
            style="border-radius: 30px"
            expand-icon-class="text-white"
            expand-separator
            label="مغایرت واریزها در ایکپ"
        >
          <q-table
              title="مغایرت واریزها در ایکپ"
              :data="not_in_ecap_bd"
              :columns="columns_bd"
              :pagination="pagination"
              row-key="name"
          >
            <template v-slot:top-right>
              <q-btn
                  color="primary"
                  icon-right="archive"
                  label="ذخیره در فرمت CSV"
                  no-caps
                  @click="exportTable(not_in_ecap_bd ,columns_bd)"
              />
            </template>
          </q-table>
        </q-expansion-item>
        <q-expansion-item
            class="shadow-1 overflow-hidden q-ma-sm"
            icon="explorer"
            header-class="bg-primary text-white"
            style="border-radius: 30px"
            expand-icon-class="text-white"
            expand-separator
            label="مغایرت واریزها در بانک"
        >
          <q-table
              title="مغایرت واریزها در بانک"
              :data="not_in_bankprint_bd"
              :columns="columns_bd"
              :pagination="pagination"
              row-key="name"
          >
            <template v-slot:top-right>
              <q-btn
                  color="primary"
                  icon-right="archive"
                  label="ذخیره در فرمت CSV"
                  no-caps
                  @click="exportTable(not_in_bankprint_bd ,columns_bd)"
              />
            </template>
          </q-table>
        </q-expansion-item>
        <q-expansion-item
            class="shadow-1 overflow-hidden q-ma-sm"
            icon="explorer"
            header-class="bg-primary text-white"
            style="border-radius: 30px"
            expand-icon-class="text-white"
            expand-separator
            label="مغایرت برداشت ها در ایکپ"
        >
          <q-table
              title="مغایرت برداشت ها در ایکپ"
              :data="not_in_ecap_bs"
              :columns="columns_bs"
              :pagination="pagination"
              row-key="name"
          >
            <template v-slot:top-right>
              <q-btn
                  color="primary"
                  icon-right="archive"
                  label="ذخیره در فرمت CSV"
                  no-caps
                  @click="exportTable(not_in_ecap_bs ,columns_bs)"
              />
            </template>
          </q-table>
        </q-expansion-item>
        <q-expansion-item
            class="shadow-1 overflow-hidden q-ma-sm"
            icon="explorer"
            header-class="bg-primary text-white"
            style="border-radius: 30px"
            expand-icon-class="text-white"
            expand-separator
            label="مغایرت برداشت ها در بانک"
        >
          <q-table
              title="مغایرت برداشت ها در بانک"
              :data="not_in_bankprint_bs"
              :columns="columns_bs"
              :pagination="pagination"
              row-key="name"
          >
            <template v-slot:top-right>
              <q-btn
                  color="primary"
                  icon-right="archive"
                  label="ذخیره در فرمت CSV"
                  no-caps
                  @click="exportTable(not_in_bankprint_bs ,columns_bs)"
              />
            </template>
          </q-table>
        </q-expansion-item>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex"
import axios from 'axios'
import {exportFile} from 'quasar'

function wrapCsvValue(val, formatFn) {
  let formatted = formatFn !== void 0
      ? formatFn(val)
      : val
  formatted = formatted === void 0 || formatted === null
      ? ''
      : String(formatted)
  formatted = formatted.split('"').join('""')
  return `"${formatted}"`
}

export default {
  name: "contradiction",
  data() {
    return {
      pagination: {
        sortBy: 'BaEvent_Date',
      },
      bankInfo: "",
      startDate: null,
      endDate: null,
      bankYear: null,
      years: [
        '1399', '1398', '1397', '1396', '1395', '1394', '1393'
      ],
      columns_bd: [
        {name: 'BaEvent_Date', label: 'تاریخ', field: 'BaEvent_Date', sortable: true, align: 'center'},
        {
          name: 'baevent_bd',
          label: 'مبلغ(ریال)',
          field: 'BaEvent_BD',
          // eslint-disable-next-line no-unused-vars
          format: (val) => `${this.formatAsCurrency(val, 0)}`,
          sortable: true,
          align: 'center'
        },
        {name: 'BaEvent_Desc', label: 'شرح', field: 'BaEvent_Desc', align: 'left'},
      ],
      columns_bs: [
        {name: 'BaEvent_Date', label: 'تاریخ', field: 'BaEvent_Date', sortable: true, align: 'center'},
        {
          name: 'baevent_bd',
          label: 'مبلغ(ریال)',
          field: 'BaEvent_BS',
          // eslint-disable-next-line no-unused-vars
          format: (val) => `${this.formatAsCurrency(val, 0)}`,
          sortable: true,
          align: 'center'
        },
        {name: 'BaEvent_Desc', label: 'شرح', field: 'BaEvent_Desc', align: 'left'},
      ],
      not_in_ecap_bd: [],
      not_in_bankprint_bd: [],
      not_in_ecap_bs: [],
      not_in_bankprint_bs: [],
      bankDateInfo: {
        startDate: null,
        endDate: null
      }
    }
  },
  computed: {
    file_upload_url_cb() {
      let localStartDate = this.startDate.replace(/\//g, "-");
      let localEndDate = this.endDate.replace(/\//g, "-");
      return `${axios.defaults.baseURL}/diff_print_bank/${this.$route.params.id}/${this.bankYear}/${localStartDate}/${localEndDate}`
    }
  },
  methods: {
    ...mapActions({
      login: "Authenticate/login",
      getBankInfo: "BankInfo/getBankInfo"
    }),
    factoryFn() {
      this.not_in_ecap_bd = [];
      const token = this.$store.state.accessToken;
      if (this.startDate === null || this.endDate === null) {
        this.$q.notify({
          type: 'negative',
          message: 'لطفا تاریخ شروع و پایان گزارش را انتخاب نمایید'
        })
        this.$refs.uploader.reset()
        return null
      } else
        return {
          url: this.file_upload_url_cb,
          method: 'POST',
          headers: [
            {name: 'Authorization', value: `JWT ${token}`}
          ]
        }
    },
    // eslint-disable-next-line no-unused-vars
    onUploaded({info, xhr}) {
      this.not_in_ecap_bd = JSON.parse(xhr.response).not_in_ecap_bd;
      this.not_in_ecap_bd = JSON.parse(JSON.stringify(this.not_in_ecap_bd));

      this.not_in_bankprint_bd = JSON.parse(xhr.response).not_in_bankprint_bd;
      this.not_in_bankprint_bd = JSON.parse(JSON.stringify(this.not_in_bankprint_bd));

      this.not_in_ecap_bs = JSON.parse(xhr.response).not_in_ecap_bs;
      this.not_in_ecap_bs = JSON.parse(JSON.stringify(this.not_in_ecap_bs));

      this.not_in_bankprint_bs = JSON.parse(xhr.response).not_in_bankprint_bs;
      this.not_in_bankprint_bs = JSON.parse(JSON.stringify(this.not_in_bankprint_bs));

      let bs = this._.merge(this.not_in_bankprint_bd, this.not_in_bankprint_bs);
      this.bankDateInfo.startDate = this._.min(bs)["BaEvent_Date"];
      this.bankDateInfo.endDate = this._.max(bs)["BaEvent_Date"]

      this.$q.notify({
        message: 'فرایند مغایرت گیری به اتمام رسید',
        color: 'secondary',
        position: 'top',
        icon: 'info'
      })
    },
    onUploadFinshed() {
      this.$refs.uploader.reset()
    },
    onRejectUpload(rejectedEntries) {
      this.$q.notify({
        type: 'negative',
        message: `${rejectedEntries.length} file(s) did not pass validation constraints`
      })
    },
    getbankInfo() {
      this.getBankInfo(this.$route.params.id).then((res) => {
        let resData = res.data.bankinfo[0];
        this.bankInfo = `بانک ${resData.Bank_Name} شعبه  ${resData.Bank_shobe} به شماره حساب ${resData.Bank_Hesab}`;
      });
    },
    formatAsCurrency(value, dec) {
      dec = dec || 0
      if (value === null) {
        return 0
      }
      return '' + value.toFixed(dec).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
    },
    exportTable(data, columns) {
      const content = [columns.map(col => wrapCsvValue(col.label))].concat(
          data.map(row => columns.map(col => wrapCsvValue(
              typeof col.field === 'function'
                  ? col.field(row)
                  : row[col.field === void 0 ? col.name : col.field],
              col.format
          )).join(','))
      ).join('\r\n')

      const status = exportFile(
          'table-export.csv',
          content,
          'text/csv'
      )

      if (status !== true) {
        this.$q.notify({
          message: 'مرورگر بارگیری فایل را رد کرد...',
          color: 'negative',
          position: 'top',
          icon: 'warning'
        })
      }
    }
  },
  created() {
    this.getbankInfo();
  },
  watch: {
    $route() {
      this.not_in_ecap_bd = [];
      this.not_in_bankprint_bd = [];
      this.not_in_ecap_bs = [];
      this.not_in_bankprint_bs = [];
      this.startDate = "";
      this.endDate = "";
      this.$refs.uploader.reset()
      this.getbankInfo();
    }
  }
}
</script>

<style scoped>

</style>
